import React from 'react';
import EVAverageGraph, {EVAverageGraphType} from '@di-shared/features/home/kr/ev-battery/EVAverageGraph';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {GetEvBatteryManagementTripResponse} from '@di-shared/api/di/__generated';
import highSpeedRateStatus = GetEvBatteryManagementTripResponse.highSpeedRateStatus;

interface HighSpeedRatioProps {
  user: HighSpeedCount;
  avgCustomer: HighSpeedCount;
  highSpeedRateStatus: highSpeedRateStatus;
}

interface HighSpeedCount {
  highSpeedDrivingCount: number;
  normalSpeedDrivingCount: number;
}

function getDescKey(highSpeedRatioType: highSpeedRateStatus) {
  switch (highSpeedRatioType) {
    case highSpeedRateStatus.LOW:
      return 'T30409';
    case highSpeedRateStatus.MEDIUM:
      return 'T30410';
    case highSpeedRateStatus.HIGH:
      return 'T30411';
  }
}

function HighSpeedRatio({user, avgCustomer, highSpeedRateStatus}: HighSpeedRatioProps) {
  const {t} = useInferableTranslation();

  return (
    <EVAverageGraph
      title={t('T30403')}
      desc={t(getDescKey(highSpeedRateStatus))}
    >
      <EVAverageGraph.BarGraph
        filledAreaRatio={user.highSpeedDrivingCount / (user.normalSpeedDrivingCount + user.highSpeedDrivingCount)}
        dashedAreaRatio={avgCustomer.highSpeedDrivingCount / (avgCustomer.normalSpeedDrivingCount + avgCustomer.highSpeedDrivingCount)}
        graphType={EVAverageGraphType.TYPE_HIGH_SPEED}
        Tags={[
          {
            title: t('T30415'),
            count: user.normalSpeedDrivingCount,
          },
          {
            title: t('T30416'),
            count: user.highSpeedDrivingCount,
            type: EVAverageGraphType.TYPE_HIGH_SPEED,
          },
        ]}
      />
    </EVAverageGraph>
  );
}

export default HighSpeedRatio;
